









import Vue from "vue";
export default Vue.extend({
  props: {
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    text: {
      get(): string {
        return this.value;
      },
      set(value: string): void {
        this.$emit("input", value);
      }
    }
  }
});
